import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { QueryParamsModel } from '../../../../core/_base/crud';
import { Document } from '../models';

export enum DocumentActionTypes {
  ToggleDocumentPageLoading = '[Document] Toggle Document Page Loading',
  ToggleDocumentActionLoading = '[Document] Toggle Document Action Loading',
  RequestDocumentPage = '[Document] Request Document Page',
  LoadDocumentPage = '[Document] Load Document Page',
  CancelDocumentPage = '[Document] Cancel Document Page',
  CreateDocument = '[Document] Create Document',
  CreateDocumentOnServer = '[Document] Create Document On Server',
  UpdateDocument = '[Document] Update Document',
  UpdateDocumentOnServer = '[Document] Update Document On Server',
  ThrowDocumentError = '[Document] Throw Document Error',
  ClearDocumentError = '[Document] Clear Document Error',
}

export class ToggleDocumentPageLoading implements Action {
  readonly type = DocumentActionTypes.ToggleDocumentPageLoading;

  constructor(public payload: { pageLoading: boolean }) {}
}

export class ToggleDocumentActionLoading implements Action {
  readonly type = DocumentActionTypes.ToggleDocumentActionLoading;

  constructor(public payload: { actionLoading: boolean }) {}
}

export class RequestDocumentPage implements Action {
  readonly type = DocumentActionTypes.RequestDocumentPage;

  constructor(public payload: { query: QueryParamsModel }) {}
}

export class LoadDocumentPage implements Action {
  readonly type = DocumentActionTypes.LoadDocumentPage;

  constructor(
    public payload: { documents: Document[]; totalCount: number; query: QueryParamsModel },
  ) {}
}

export class CancelDocumentPage implements Action {
  readonly type = DocumentActionTypes.CancelDocumentPage;
}

export class CreateDocument implements Action {
  readonly type = DocumentActionTypes.CreateDocument;

  constructor(public payload: { document: Document }) {}
}

export class CreateDocumentOnServer implements Action {
  readonly type = DocumentActionTypes.CreateDocumentOnServer;

  constructor(public payload: { document: Document; close(dialogResult?: any): void }) {}
}

export class UpdateDocument implements Action {
  readonly type = DocumentActionTypes.UpdateDocument;

  constructor(public payload: { document: Update<Document> }) {}
}

export class UpdateDocumentOnServer implements Action {
  readonly type = DocumentActionTypes.UpdateDocumentOnServer;

  constructor(public payload: { document: Document; close(dialogResult?: any): void }) {}
}

export class ThrowDocumentError implements Action {
  readonly type = DocumentActionTypes.ThrowDocumentError;

  constructor(public payload: { error: any }) {}
}

export class ClearDocumentError implements Action {
  readonly type = DocumentActionTypes.ClearDocumentError;
}

export type DocumentActions =
  | ToggleDocumentPageLoading
  | ToggleDocumentActionLoading
  | RequestDocumentPage
  | LoadDocumentPage
  | CancelDocumentPage
  | CreateDocument
  | CreateDocumentOnServer
  | UpdateDocument
  | UpdateDocumentOnServer
  | ThrowDocumentError
  | ClearDocumentError;
